module.exports = __webpack_public_path__ + "static/media/combineAadharSample.a185cdea.jpg";